import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useOnboarding } from './OnboardingProvider';
import { EditCertificationsForm } from '../cv/forms/EditCertificationsForm';
import { OnboardingWebStep } from './web-step-chrome';

/**
 * Certifications: an OPTIONAL CV section. Normally off-flow (reached from the
 * CV preview / checklist, Back and Save return there); in the manual-build
 * wizard it joins the linear flow, where the same resolver calls advance to
 * the next section instead. No progress bar.
 */
export function StepCertifications() {
  const { t } = useTranslation('auth');
  const { nextStep, prevStep } = useOnboarding();
  // Off-flow (preview editor): the resolvers return to 'complete'. In the
  // manual-build wizard this step IS in the flow, so the same calls advance
  // linearly instead — see onboarding-navigation.ts.
  const advance = useCallback(() => void nextStep(), [nextStep]);
  const goBack = useCallback(() => void prevStep(), [prevStep]);

  return (
    <OnboardingWebStep
      titleBase={t('onboarding.certifications.titleBase', { defaultValue: 'Add your' })}
      titleAccent={t('onboarding.certifications.titleAccent', { defaultValue: 'certifications' })}
      subtitle={t('onboarding.certifications.subtitle', { defaultValue: 'Licenses and credentials you’ve earned' })}
      onBack={goBack}
    >
      <EditCertificationsForm
        onSave={advance}
        closeOnSave={false}
        ctaLabel={t('onboarding.done', { defaultValue: 'Done' })}
      />
    </OnboardingWebStep>
  );
}
